import { render, staticRenderFns } from "./contactsPage.vue?vue&type=template&id=69b0bb14&"
import script from "./contactsPage.vue?vue&type=script&lang=ts&"
export * from "./contactsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports